import { useContext } from 'react';
import Alert from '@pelckmans/elementis/components/alert';
import Button from '@pelckmans/elementis/components/button';
import ModalContext from '../../contexts/ModalContext';
import AddLicenseModal from '../AddLicenseModal';
import { useTranslation } from 'react-i18next';
import ModuleContext from '../../pages/material/_contexts/ModuleContext';

const BASE_KEY = 'SHARED_COMPONENTS.ALERTS';

interface Props {
  message: string;
}

export default function ModuleLicenseAlert({ message }: Props) {
  const { showModal } = useContext(ModalContext);
  const { t } = useTranslation();

  const { refetch: refetchModule } = useContext(ModuleContext);

  return (
    <Alert
      prominence="warning"
      actions={{
        'aria-label': undefined,
        role: 'group',
        size: 'sm',
        children: (
          <Button
            key="info-ok"
            prominence="warning"
            size="sm"
            onClick={() => showModal(<AddLicenseModal id="add-license-modal" onRefetch={refetchModule} />)}
          >
            {t(`${BASE_KEY}.ACTIVATE_BUTTON`)}
          </Button>
        ),
      }}
    >
      {message}
    </Alert>
  );
}
